import React from 'react'
import { Box } from '@mui/material'
import Loader from 'src/designSystem/Loader'
import { useAdvancedCaseload } from '../api/AdvancedCaseloadProvider'
import EmptyState from '../components/EmptyState'
import { serviceUnreachableHint } from '../serviceUnreachableHint'
import { advancedColors } from '../theme'
import { TOUR_ANCHORS } from '../tour/anchors'
import AdvancedCaseloadList from './AdvancedCaseloadList'
import { sideTintSx } from './caseloadChrome'

type Props = {
  selectedUid?: string
}

const AdvancedSidebar = ({ selectedUid }: Props) => {
  const caseload = useAdvancedCaseload()
  const patients = caseload.status === 'ready' ? Object.values(caseload.byUid) : []

  return (
    <Box
      data-tour={TOUR_ANCHORS.caseload}
      sx={{
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        backgroundColor: advancedColors.deep,
        ...sideTintSx,
      }}
    >
      <Box sx={{ flex: 1, overflowY: 'auto' }}>
        {caseload.status === 'loading' && <Loader size="large" />}

        {caseload.status === 'error' && (
          <EmptyState tone="dark" title="Advanced is not responding" description={serviceUnreachableHint()} />
        )}

        {caseload.status === 'disabled' && (
          <EmptyState
            tone="dark"
            title="Advanced is turned off"
            description="Set ADVANCED_DASHBOARD_ENABLED=true in .env."
          />
        )}

        {caseload.status === 'ready' &&
          (patients.length === 0 ? (
            <EmptyState
              tone="dark"
              title="No Advanced participants"
              description="Participants appear here once you are on their Advanced care team."
            />
          ) : (
            <AdvancedCaseloadList patients={patients} selectedUid={selectedUid} />
          ))}
      </Box>
    </Box>
  )
}

export default AdvancedSidebar
